module.exports = __webpack_public_path__ + "static/media/folder.529efc46.svg";